import { NgModule } from '@angular/core';

import { SharedModule } from '../../shared/shared.module';
import { MainRoutingModule } from './main-routing.module';

@NgModule({
  imports: [MainRoutingModule, SharedModule],
})
export class MainModule {}
